import BreadCrumb from "../screens/Common/BreadCrumb";
import React from "react";

import LayoutContainer from "../screens/layout/admin-dashboard";
import CategoryManagementList from "../screens/CategoryManagement/CategoryList";

const breadCrumbData = [{ link: "/category-list", name: "Project List" }];
const CategoryManagement = () => (
  <>
    <LayoutContainer>
      <BreadCrumb data={breadCrumbData} />
      <CategoryManagementList />
    </LayoutContainer>
  </>
);

export default CategoryManagement;